import { render, staticRenderFns } from "./NavBarProfile.vue?vue&type=template&id=6f904bd8&scoped=true"
import script from "./NavBarProfile.vue?vue&type=script&lang=ts"
export * from "./NavBarProfile.vue?vue&type=script&lang=ts"
import style0 from "./NavBarProfile.vue?vue&type=style&index=0&id=6f904bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f904bd8",
  null
  
)

export default component.exports